export const ROUTES = {
  ROOT: '/',
  DASHBOARD: '/dashboard',
  ORGANIZATIONS: '/organizations',
  DEALERS: '/dealers',
  ACCOUNT_SETUP: '/account-setup',
  BOOKINGS: '/dashboard/bookings',
  BOOKING_DETAIL: (id: string | number) => `/dashboard/bookings/${id}`,
  RESOURCES: '/dashboard/resources',
  CUSTOMERS: '/dashboard/customers',
  SERVICES: '/dashboard/services',
  KNOWLEDGE_BASE: '/dashboard/knowledge-base',
  FORMS: '/dashboard/forms',
  FORMS_CREATE: '/dashboard/forms/create',
  FORMS_DETAIL: '/dashboard/forms/:formId',
  FORMS_EDIT: '/dashboard/forms/edit/:formId',
  PHONE: '/dashboard/phone',
  PHONE_ROUTING: (phoneNumberId: string | number) => `/dashboard/phone/routing/${phoneNumberId}`,
  SETTINGS: '/dashboard/settings',
  SETTINGS_INTEGRATIONS: '/dashboard/settings/integrations',
  SUBSCRIPTIONS: 'subscriptions',
} as const;
